import React, { useRef } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import excelIcon from '../../assets/excel-icon.png';
import "./ExcelImportButton.css";
import { useAuth } from "../../context/AuthContext";

const ExcelImportButtonOrder = ({ setFileName }) => {
  const { token, role } = useAuth();
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      console.log('data', jsonData);

      const formData = new FormData();
      formData.append("file", file);

      const baseUrl = process.env.REACT_APP_BASE_URL_BE;
      const uploadUrl = `${baseUrl}/algorithm/upload/order`;

      try {
        const response = await axios.post(uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          console.log("Successfully uploaded order file:", response.data);
          if (setFileName) setFileName(file.name);
        }
      } catch (err) {
        console.error("Error uploading order file:", err);
      }

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      document.activeElement.blur();
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className='container-button-icon'>
      <button
        onClick={() => fileInputRef.current.click()}
        className="import-button nm-cursor-non-text"
      >
        <img src={excelIcon} alt="" className="excel-icon" />
        ファイル選択
      </button>
      <input
        type="file"
        accept=".xlsx, .xls"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ExcelImportButtonOrder;
